import { useState, useContext, useEffect } from "react";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { FaCheckCircle, FaCoins, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Drivers/DriverSetting/DriverMyWallet.css";
import DriverSettingsMasterLayout from "../../../layouts/Drivers/DriverSettingsMasterLayout";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const DriverMyWallet = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  const [totalbalance, setTotalBalance] = useState(0);
  const [totalcoins, setTotalCoins] = useState(0);
  const [activeTab, setActiveTab] = useState("trip");
  const [topupHistory, setTopupHistory] = useState([]);
  const [topupLoading, setTopupLoading] = useState(false);

  const tripHistoryData = [
    { id: 1, passengerName: "Ahmed Ali", date: "23 March, 2024", time: "10:30 AM", from: "F-7 Markaz", to: "Blue Area", amount: "Rs450" },
    { id: 2, passengerName: "Sara Khan", date: "22 March, 2024", time: "02:15 PM", from: "PWD", to: "Bahria Town", amount: "Rs680" },
    { id: 3, passengerName: "Hassan Raza", date: "21 March, 2024", time: "09:00 AM", from: "Airport", to: "Rawalpindi", amount: "Rs950" },
  ];

  const handleTripHistoryTab = () => setActiveTab("trip");

  const handleTopupHistoryTab = () => {
    setActiveTab("topup");
    setTopupLoading(true);
    axios.post(`${baseUrl}/driver/topup/viewTopupHistory`, {}, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setTopupHistory(response.data.topup);
        setTopupLoading(false);
      }
    }).catch((error) => {
      console.log(error);
      setTopupLoading(false);
    });
  };

  const handleTopUpWallet = () => navigate("/driver/topup");
  const handleGetCoins = () => navigate("/driver/qrcode");

  const statusColor = (status) => {
    if (status === "Approved") return "#1B9B82";
    if (status === "Rejected") return "red";
    return "#f59e0b";
  };

  const fetchWallet = () => {
    axios.post(`${baseUrl}/driver/topup/getWallet`, {}, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setTotalBalance(response.data.balance);
      }
    }).catch((error) => console.log(error));
  };

  const fetchCoinsBalance = () => {
    axios.post(`${baseUrl}/driver/topup/getCoinsBalance`, {}, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setTotalCoins(response.data.balance);
      }
    }).catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchWallet();
    fetchCoinsBalance();
  }, []);

  return (
    <DriverSettingsMasterLayout screenName={"MyWallet"} centered={true}>
      <div className="driver-mywallet-container">
        <div className="driver-mywallet-content">
          <Container className="driver-mywallet-wrapper">

            {/* Balance Card */}
            <Row className="mt-4">
              <Col>
                <div className="driver-mywallet-balance-card">
                  <div className="driver-mywallet-balance-header">
                    <div>
                      <p className="driver-mywallet-balance-label">Total Balance</p>
                      <h2 className="driver-mywallet-balance-amount">
                        Rs{Number(totalbalance || 0).toFixed(2)}
                      </h2>
                    </div>
                    <Button className="driver-mywallet-topup-btn" onClick={handleTopUpWallet}>
                      TopUp Wallet
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Coins Card */}
            <Row className="mt-4">
              <Col>
                <div className="driver-mywallet-balance-card">
                  <div className="driver-mywallet-balance-header">
                    <div>
                      <p className="driver-mywallet-balance-label">Total Coins</p>
                      <h2 className="driver-mywallet-balance-amount">
                        <FaCoins size={16} /> {Number(totalcoins || 0).toFixed(2)}
                      </h2>
                    </div>
                    <Button className="driver-mywallet-topup-btn" onClick={handleGetCoins}>
                      Get Coin
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Tabs */}
            <Row className="mt-4">
              <Col>
                <div className="driver-mywallet-tabs">
                  <Button className={`driver-mywallet-tab ${activeTab === "trip" ? "active" : ""}`} onClick={handleTripHistoryTab}>
                    Trip History
                  </Button>
                  <Button className={`driver-mywallet-tab ${activeTab === "topup" ? "active" : ""}`} onClick={handleTopupHistoryTab}>
                    TopUp History
                  </Button>
                </div>
              </Col>
            </Row>

            {/* Trip History */}
            {activeTab === "trip" && (
              <Row className="mt-3">
                <Col>
                  <div className="driver-mywallet-history-list">
                    {tripHistoryData.map((trip) => (
                      <Card key={trip.id} className="driver-mywallet-trip-card">
                        <Card.Body className="driver-mywallet-trip-body">
                          <div className="driver-mywallet-trip-icon"><FaUser /></div>
                          <div className="driver-mywallet-trip-details">
                            <h6 className="driver-mywallet-trip-passenger">{trip.passengerName}</h6>
                            <p className="driver-mywallet-trip-route">{trip.from} → {trip.to}</p>
                            <div className="driver-mywallet-trip-datetime">
                              <span className="driver-mywallet-trip-date">{trip.date}</span>
                              <span className="driver-mywallet-trip-time">{trip.time}</span>
                            </div>
                          </div>
                          <div className="driver-mywallet-trip-right">
                            <div className="driver-mywallet-trip-amount">{trip.amount}</div>
                            <div className="driver-mywallet-trip-status">
                              <FaCheckCircle className="driver-mywallet-status-icon-success" />
                              <span className="driver-mywallet-status-text-success">Completed</span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </Col>
              </Row>
            )}

            {/* TopUp History */}
            {activeTab === "topup" && (
              <Row className="mt-3">
                <Col>
                  {topupLoading && (
                    <div className="text-center py-4">
                      <Spinner animation="border" size="sm" style={{ color: "#1B9B82" }} />
                    </div>
                  )}

                  {!topupLoading && topupHistory.length === 0 && (
                    <p style={{ textAlign: "center", color: "#aaa", fontSize: 14, padding: "20px 0" }}>
                      No TopUp request Found.
                    </p>
                  )}

                  {!topupLoading && topupHistory.length > 0 && (
                    <div className="driver-mywallet-history-list">
                      {topupHistory.map((item) => (
                        <Card key={item.id} className="driver-mywallet-trip-card">
                          <Card.Body className="driver-mywallet-trip-body">
                            <div className="driver-mywallet-trip-icon"><FaCoins /></div>
                            <div className="driver-mywallet-trip-details">
                              <h6 className="driver-mywallet-trip-passenger">TopUp Request #{item.id}</h6>
                              <div className="driver-mywallet-trip-datetime">
                                <span className="driver-mywallet-trip-date">{new Date(item.created_at).toLocaleDateString()}</span>
                                <span className="driver-mywallet-trip-time">{new Date(item.created_at).toLocaleTimeString()}</span>
                              </div>
                            </div>
                            <div className="driver-mywallet-trip-right">
                              <div className="driver-mywallet-trip-amount">Rs{Number(item.amount).toLocaleString()}</div>
                              <div className="driver-mywallet-trip-status">
                                <span style={{ color: statusColor(item.status), fontWeight: 600, fontSize: 12 }}>
                                  {item.status}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>
            )}

            <div className="driver-mywallet-bottom-spacer"></div>
          </Container>
        </div>
      </div>
    </DriverSettingsMasterLayout>
  );
};

export default DriverMyWallet;